import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogService } from '@shared/confirm-dialog/confirm-dialog.service';
import { ICurrentUser } from '@shared/interfaces';
import { LocalStorageJwtService } from 'src/app/feature/auth/local-storage-jwt.service';
import { ProfileService } from '../profile.service';
import { USER_DASHBOARD_BASE_PATH } from '../routes/profile.routes.names';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: UntypedFormGroup;
  private currentUser: ICurrentUser;
  isChangeUserFormValue = false;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private profileService: ProfileService,
    private localStorageJwtService: LocalStorageJwtService,
    private confirmDialogService: ConfirmDialogService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.currentUser = this.localStorageJwtService.getCurrentUser();
    this.initializeForm();
    this.resetPasswordForm.valueChanges.subscribe((changed) => {
      this.isChangeUserFormValue = true;
    });
  }

  private initializeForm() {
    this.resetPasswordForm = this.formBuilder.group(
      {
        oldPassword: ['', Validators.required],
        newPassword: ['', [Validators.required, Validators.pattern('^(?=.{6,}).*$')]],
        confirmPassword: ['']
      },
      {
        validator: this.checkConfirmPasswords('newPassword', 'confirmPassword')
      }
    );
  }

  noWhiteSpaceAllow(event: any) {
    if (event.which === 32) {
      event.preventDefault();
    }
  }

  /**
   *
   * @param control
   * validate confirm password and password is same or not
   */
  checkConfirmPasswords(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  public async onSubmit() {
    if (this.resetPasswordForm.invalid) {
      for (const i in this.resetPasswordForm.controls) {
        if (this.resetPasswordForm.controls[i]) {
          this.resetPasswordForm.controls[i].markAsTouched();
          this.resetPasswordForm.controls[i].markAsDirty();
        }
      }
      return;
    }
    try {
      const accessToken = this.localStorageJwtService.getItem().accessToken;
      const oldPassword = this.resetPasswordForm.controls.oldPassword.value;
      const newPassword = this.resetPasswordForm.controls.newPassword.value;
      const confirmPassword = this.resetPasswordForm.controls.confirmPassword.value;
      await this.profileService.resetPassword(
        oldPassword,
        newPassword,
        confirmPassword,
        this.currentUser.username,
        accessToken
      );
      this.router.navigate([`/${USER_DASHBOARD_BASE_PATH}`]);
    } catch (error) {
      console.log(error);
    }
  }

  cancel() {
    if (this.isChangeUserFormValue) {
      const message = this.translate.instant('profile.confirmation_message');
      this.confirmDialogService.showConfirmDialog(message).subscribe((result) => {
        if (result === 'yes') {
          this.router.navigate([`/${USER_DASHBOARD_BASE_PATH}`]);
        }
      });
    } else {
      this.router.navigate([`/${USER_DASHBOARD_BASE_PATH}`]);
    }
  }
}
